import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "082c13c2-3f9c-4eb5-b644-0170c8c4d94a",
    label: "DG(BLDG)'s Office Order No. 17 of 2018-2019",
    date: "19/03/2019",
    subject:
      "Hearing files us 416, 400(1) to transmit through DyCE and EE after approval of the authority",
  },
  {
    fileStoreId: "edc00f78-7291-4a4b-8d90-24923d1c4eab",
    label: "DG(BLDG)'s Office Order No. 15 of 2018-2019",
    date: "01/03/2019",
    subject:
      "NOC-Observation of WBFES before Deposition of fees us 400(1), 416",
  },
  {
    fileStoreId: "b14fd976-2bab-49bb-8117-92dd3eadfa59",
    label: "DG(BLDG)'s Office Order No. 12 of 2018-2019",
    date: "26/11/2018",
    subject: "Registration of Gift Deed for strip of land",
  },
  {
    fileStoreId: "1c576086-674b-40e1-beae-f2f3adc69248",
    label: "DG(BLDG)'s Office Order No. 10 of 2018-2019",
    date: "01/11/2018",
    subject: "Conditions of Coner plot to place before MBC",
  },
  {
    fileStoreId: "17ec2fad-ce2c-4f47-a4ef-ee957e5a2b93",
    label: "DG(BLDG)'s Office Order No. 06 of 2018-2019",
    date: "31/07/2018",
    subject:
      "Intervention of Credai Bengal required for prevention of mosquito breeding",
  },
];

const Building_OfficeOreder_2018 = () => (
  <TableStructure
    title="Office Order/ 2018"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2018;
